(ns ncr.etc.patternfly-charts
  (:require ["@patternfly/react-charts/dist/esm/components/Chart/Chart" :refer [Chart]]
            ["@patternfly/react-charts/dist/esm/components/ChartAxis/ChartAxis" :refer [ChartAxis]]
            ["@patternfly/react-charts/dist/esm/components/ChartBar/ChartBar" :refer [ChartBar]]
            ["@patternfly/react-charts/dist/esm/components/ChartGroup/ChartGroup" :refer [ChartGroup]]
            ["@patternfly/react-charts/dist/esm/components/ChartLabel/ChartLabel" :refer [ChartLabel]]
            ["@patternfly/react-charts/dist/esm/components/ChartLine/ChartLine" :refer [ChartLine]]
            ["@patternfly/react-charts/dist/esm/components/ChartScatter/ChartScatter" :refer [ChartScatter]]
            ["@patternfly/react-charts/dist/esm/components/ChartStack/ChartStack" :refer [ChartStack]]
            ["@patternfly/react-charts/dist/esm/components/ChartTooltip/ChartTooltip" :refer [ChartTooltip]]
            ["@patternfly/react-charts/dist/esm/components/ChartVoronoiContainer/ChartVoronoiContainer" :refer [ChartVoronoiContainer]]
            [ncr.etc.pf :refer [wrap]]))

(def chart (wrap Chart))
(def axis (wrap ChartAxis))
(def bar (wrap ChartBar))
(def group (wrap ChartGroup))
(def label (wrap ChartLabel))
(def line (wrap ChartLine))
(def scatter (wrap ChartScatter))
(def stack (wrap ChartStack))
(def tooltip (wrap ChartTooltip))
(def voronoi-container (wrap ChartVoronoiContainer))
